module.exports = new __parcel__URL__("elf-title-talent-12.e2610034.gif").toString();